// react
import React, { Fragment, useEffect, useState } from "react";
// store
import { paymentService } from "../../../../store/services/ServicePayment";
import { LOADING_TIME } from "../../../../store/config";
// components
import HeaderTitle from "../../../../components/others/HeaderTitle";
import Loading from "../../../../components/others/Loading";
import ClientInvoicesTable from "./ClientInvoicesTable";
import { Card, Form, Button, Icon } from "semantic-ui-react";
import { DateInput } from "semantic-ui-calendar-react";
import moment from "moment";

// component
const ClientInvoices = () => {

    // state
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [filters, setFilters] = useState({
        from: moment().startOf('month').format("DD.MM.YYYY"),
        to: moment().endOf('month').format("DD.MM.YYYY")
    })

    const [stats, setStats] = useState({
        totalInvoices: 0,
        totalPaid: 0,
        totalNonPaid: 0,
    })
    const [isLoading, setIsLoading] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [showFilters, setShowFilters] = useState(false);
    const [selectedFilter, setSelectedFilter] = useState("paid");

    // fetch data
    async function fetchData() {
        setIsLoading(true);
        let params = `?from=${moment(filters.from, "DD.MM.YYYY").format("YYYY-MM-DD")}&to=${moment(filters.to, "DD.MM.YYYY").format("YYYY-MM-DD")}`;
        const result = await paymentService.getInvoicesForUser(params);

        if (result.status === 200) {
            // calculate stats
            const invoices = result.response

            let totalPaidInvoices = 0;
            let totalNonPaidInvoices = 0;
            let totalInvoices = invoices.length;
            for (let i = 0; i < invoices.length; i++) {
                if (invoices[i].status === 3) { // paid
                    totalPaidInvoices += 1
                } else {
                    totalNonPaidInvoices += 1
                }
            }


            setData(invoices);
            setStats({
                totalInvoices: totalInvoices,
                totalPaid: totalPaidInvoices,
                totalNonPaid: totalNonPaidInvoices,
            })
        }

        setTimeout(function () {
            setIsLoading(false);
        }, LOADING_TIME);
    }

    useEffect(() => {
        let filtered = [];
        if (selectedFilter === "paid") {
            filtered = data.filter((item) => item.status === 3);
        } else if (selectedFilter === "unpaid") {
            filtered = data.filter((item) => item.status !== 3);
        } else {
            filtered = data;
        }
        setFilteredData(filtered);
    }, [data, selectedFilter]);

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        const media = window.matchMedia("(max-width: 768px)");
        const handleChange = () => setIsMobile(media.matches);
        handleChange();
        if (media.addEventListener) {
            media.addEventListener("change", handleChange);
        } else {
            media.addListener(handleChange);
        }
        return () => {
            if (media.removeEventListener) {
                media.removeEventListener("change", handleChange);
            } else {
                media.removeListener(handleChange);
            }
        };
    }, []);

    const handleFilter = async () => {
        await fetchData()
        if (isMobile) {
            setShowFilters(false)
        }
    }

    // template
    return (
        <Fragment>
            <HeaderTitle title="Moje Objednávky" />
            <section>
                {isMobile && (
                    <div style={{ marginBottom: "1rem" }}>
                        <div
                            onClick={() => setShowFilters(!showFilters)}
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                padding: "0.85rem 1rem",
                                background: "#f8f9fa",
                                border: "1px solid #e0e0e0",
                                borderRadius: "8px",
                                cursor: "pointer",
                                transition: "all 0.2s ease"
                            }}
                        >
                            <div style={{ display: "flex", gap: "0.65rem" }}>
                                <Icon name="sliders horizontal" style={{ margin: 0, fontSize: "1.05rem", color: "#555" }} />
                                <span style={{ fontSize: "0.95rem", fontWeight: 600, color: "#333" }}>Filtrovať</span>
                            </div>
                            <div style={{ display: "flex", gap: "0.6rem" }}>
                                <span style={{ fontSize: "0.85rem", color: "#666", fontWeight: 500 }}>{filters.from} - {filters.to}</span>
                                <Icon name={showFilters ? "chevron up" : "chevron down"} style={{ margin: 0, fontSize: "0.95rem", color: "#555" }} />
                            </div>
                        </div>
                    </div>
                )}

                {(showFilters || !isMobile) && (
                    <Card fluid style={{ borderRadius: "8px", border: "1px solid #e0e0e0", marginBottom: "1rem", boxShadow: "none" }}>
                        <Card.Content style={{ padding: isMobile ? "1rem" : "1.25rem" }}>
                            <Form onSubmit={handleFilter}>
                                <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr auto", gap: isMobile ? "1rem" : "1rem", alignItems: "end" }}>
                                    <Form.Field style={{ margin: 0 }}>
                                        <label style={{ fontSize: "0.85rem", fontWeight: 600, color: "#555", marginBottom: "0.4rem", display: "block" }}>
                                            Dátum od
                                        </label>
                                        <DateInput
                                            fluid
                                            required
                                            localization="sk"
                                            placeholder="DD.MM.YYYY"
                                            dateFormat="DD.MM.YYYY"
                                            value={filters.from}
                                            onChange={(e, { value }) => setFilters({ ...filters, from: value })}
                                            iconPosition="right"
                                            animation="none"
                                            closable
                                            hideMobileKeyboard
                                        />
                                    </Form.Field>
                                    <Form.Field style={{ margin: 0 }}>
                                        <label style={{ fontSize: "0.85rem", fontWeight: 600, color: "#555", marginBottom: "0.4rem", display: "block" }}>
                                            Dátum do
                                        </label>
                                        <DateInput
                                            fluid
                                            required
                                            localization="sk"
                                            placeholder="DD.MM.YYYY"
                                            dateFormat="DD.MM.YYYY"
                                            value={filters.to}
                                            onChange={(e, { value }) => setFilters({ ...filters, to: value })}
                                            iconPosition="right"
                                            animation="none"
                                            closable
                                            hideMobileKeyboard
                                        />
                                    </Form.Field>
                                    <Button
                                        fluid
                                        type="submit"
                                        style={{
                                            background: "var(--primary)",
                                            color: "#fff",
                                            borderRadius: "6px",
                                            fontWeight: 600,
                                            padding: "0.85rem 1.5rem",
                                            border: "none",
                                            minWidth: isMobile ? "100%" : "120px"
                                        }}
                                    >
                                        Potvrdiť
                                    </Button>
                                </div>
                            </Form>
                        </Card.Content>
                    </Card>
                )}

                {isLoading
                    ? <Loading />
                    :
                    <>
                        <div
                            style={{
                                display: "grid",
                                gridTemplateColumns: isMobile ? "repeat(3, minmax(0, 1fr))" : "repeat(3, 1fr)",
                                gap: isMobile ? "0.6rem" : "0.85rem",
                                marginBottom: "1rem"
                            }}
                        >
                            <div
                                onClick={() => setSelectedFilter("paid")}
                                style={{
                                    borderRadius: "8px",
                                    padding: isMobile ? "0.9rem 0.7rem" : "1.1rem 1.2rem",
                                    border: selectedFilter === "paid" ? "1.5px solid var(--primary)" : "0.5px solid #e8e8e8",
                                    background: selectedFilter === "paid" ? "#f8f9ff" : "#fff",
                                    cursor: "pointer",
                                    transition: "all 0.2s ease"
                                }}
                            >
                                <div style={{ textAlign: isMobile ? "center" : "left" }}>
                                    <div style={{ color: "#666", fontSize: isMobile ? "0.75rem" : "0.85rem", fontWeight: 500, marginBottom: "0.45rem", lineHeight: 1.2 }}>Zaplatené</div>
                                    <div style={{ fontSize: isMobile ? "1.5rem" : "2rem", fontWeight: 700, color: "#00a651", lineHeight: 1 }}>{stats.totalPaid}</div>
                                </div>
                            </div>
                            <div
                                onClick={() => setSelectedFilter("unpaid")}
                                style={{
                                    borderRadius: "8px",
                                    padding: isMobile ? "0.9rem 0.7rem" : "1.1rem 1.2rem",
                                    border: selectedFilter === "unpaid" ? "1.5px solid var(--primary)" : "0.5px solid #e8e8e8",
                                    background: selectedFilter === "unpaid" ? "#f8f9ff" : "#fff",
                                    cursor: "pointer",
                                    transition: "all 0.2s ease"
                                }}
                            >
                                <div style={{ textAlign: isMobile ? "center" : "left" }}>
                                    <div style={{ color: "#666", fontSize: isMobile ? "0.75rem" : "0.85rem", fontWeight: 500, marginBottom: "0.45rem", lineHeight: 1.2 }}>Nezaplatené</div>
                                    <div style={{ fontSize: isMobile ? "1.5rem" : "2rem", fontWeight: 700, color: "#db2828", lineHeight: 1 }}>{stats.totalNonPaid}</div>
                                </div>
                            </div>
                            <div
                                onClick={() => setSelectedFilter("all")}
                                style={{
                                    borderRadius: "8px",
                                    padding: isMobile ? "0.9rem 0.7rem" : "1.1rem 1.2rem",
                                    border: selectedFilter === "all" ? "1.5px solid var(--primary)" : "0.5px solid #e8e8e8",
                                    background: selectedFilter === "all" ? "#f8f9ff" : "#fff",
                                    cursor: "pointer",
                                    transition: "all 0.2s ease"
                                }}
                            >
                                <div style={{ textAlign: isMobile ? "center" : "left" }}>
                                    <div style={{ color: "#666", fontSize: isMobile ? "0.75rem" : "0.85rem", fontWeight: 500, marginBottom: "0.45rem", lineHeight: 1.2 }}>Celkovo</div>
                                    <div style={{ fontSize: isMobile ? "1.5rem" : "2rem", fontWeight: 700, color: "#333", lineHeight: 1 }}>{stats.totalInvoices}</div>
                                </div>
                            </div>
                        </div>
                        <ClientInvoicesTable invoices={filteredData} isLoading={isLoading} />
                    </>
                }
            </section>
        </Fragment>
    );
};

export default ClientInvoices;
